<!-- BaseModalV2.vue -->
<template>
  <div class="modal">
    <div class="modal_content">
      <!-- Header с навигацией -->
      <ModalHeader 
  v-if="flow" 
  :key="flow.length + (flow[0]?.active ? '1' : '0')"
  :is-first-screen="ferst"
  :flow="flow"
  :text="text"
  @back="TemporalyBack"
  @scroll-back="someMethod"
  @flow-click="TemporalyFlow"
/>
      <div class="modal_main">
        <!-- Первый экран выбора типа аудита -->
        <StepSelection v-if="ferst" :analysis-card="AnalysisCard" @update:analysisCard="AnalysisCard = $event"
          @continue="TemporalyNextv2" />

        <!-- ========== СЦЕНАРИЙ 1: АУДИТ РЕГЛАМЕНТА (ОДИН ФАЙЛ) ========== -->
        <template v-if="!ferst && AnalysisCard[0]">
          <!-- Шаг 1: Загрузка файла -->
          <StepUploadFile v-if="flow[0]?.active" :drag-over="DragOver1" :file-data="fileData"
            :title="'Выберите файл регламента'" :subtitle="'или перетащите сюда'" :upload-target="1"
            @update:drag-over="DragOver1 = $event" @update:file-data="fileData = $event" @file-upload="handleFileUpload"
            @drag-over-event="onDragOver" @drag-leave-event="onDragLeave" @drop-event="onDrop"
            @continue-with-file="sendFile" @continue="TemporalyNext" @error="handleError" />

          <!-- Шаг 2: Проверка типа -->
          <StepProgress v-else-if="flow[1]?.active" :is-rejected="isRejected" :percentage="percentage"
            :circumference="circumference" :progress-offset="progressOffset" :is-complete="progresOne"
            :document-info="documentInfo" :title="'Документ успешно распознан'"
            :message="'Ваш файл соответствует структуре регламента'" @continue="TemporalyNext" />

          <!-- Шаг 3: Проверка структуры -->
          <StepProgress v-else-if="flow[2]?.active" :percentage="percentage" :circumference="circumference"
            :progress-offset="progressOffset" :is-complete="progresTwo" :show-sections="true" :sections="foundSections"
            :checklist="structureChecklist" :title="'Структура соответствует эталону'"
            :message="'Все необходимые разделы присутствуют в документе'" @continue="TemporalyNext" />

          <!-- Шаг 4: Таблица ролей -->
          <StepTableRoles v-else-if="flow[3]?.active" :tumbler="tumbler" :drag-over="DragOver4" :file-data="fileData4"
            :roles="roles" :role-mappings="roleMappings" :is-loading-staffing="isLoadingStaffing" :upload-target="4"
            @update:tumbler="tumbler = $event" @update:drag-over="DragOver4 = $event"
            @update:file-data="fileData4 = $event" @file-upload="uploadStaffing" @drag-over-event="onDragOver"
            @drag-leave-event="onDragLeave" @drop-event="onDrop" @update:roles="updateRoles"
            @update:roleMappings="updateRoleMappings" @update-role="handleRoleUpdate" @delete-role="deleteRole"
            @update:mapping="handleMappingUpdate" @add-role="handleAddRole" @add-mapping="handleAddMapping"
            @move-to-main="handleMoveToMain" @save-roles="saveRoles" @continue="TemporalyNext" />

          <!-- Шаг 5: Продукт -->
          <StepProduct v-else-if="flow[4]?.active" :product="product" :quantity="quantity"
            :estimation="productEstimation" :is-loading="isAnalyzingProduct" :has-estimation="hasProductEstimation"
            @update:product="product = $event" @update:quantity="quantity = $event" @analyze="analyzeProduct"
            @continue="TemporalyNext" />

          <!-- Шаг 6: Финальный отчет -->
          <StepFinalReport
            v-else-if="flow[5]?.active"
            :final-items="final"
            :report-text="reportText"
            :price="'Free'"
            :price-description="'Единоразовая плата'"
            :show-extra-buttons="true"
            :sections="foundSections"
            :checklist="structureChecklist"
            :estimation="productEstimation"
            :has-estimation="hasProductEstimation"
            :product="product"
            :quantity="quantity"
            :roles="roles"
            :task-id="taskId"
            @restart="restartFromBeginning"
            @download="someMethod"
            @share="handleShare"
            @save="handleSave"
          />
        </template>

        <!-- ========== СЦЕНАРИЙ 2: СРАВНЕНИЕ ДОКУМЕНТОВ (ДВА ФАЙЛА) ========== -->
        <template v-if="!ferst && AnalysisCard[1]">
  <!-- Шаг 1: Загрузка двух файлов + выбор режима -->
  <div v-if="flow[0]?.active" class="modal_main_load_v2">
    <!-- Селектор режима сравнения -->
    <div class="comparison-mode-selector">
      <div class="comparison-mode-option" 
           :class="{ active: comparisonMode === 'UPSTREAM' }"
           @click="comparisonMode = 'UPSTREAM'">
        <div class="comparison-mode-radio">
          <span v-if="comparisonMode === 'UPSTREAM'" class="radio-dot"></span>
        </div>
        <div class="comparison-mode-content">
          <div class="comparison-mode-name">Эталон строже (Политика -> Регламент)</div>
          <div class="comparison-mode-description">
            Проверяемый документ должен строго подчиняться эталону и раскрывать его суть.
          </div>
        </div>
      </div>
      
      <div class="comparison-mode-option" 
           :class="{ active: comparisonMode === 'DOWNSTREAM' }"
           @click="comparisonMode = 'DOWNSTREAM'">
        <div class="comparison-mode-radio">
          <span v-if="comparisonMode === 'DOWNSTREAM'" class="radio-dot"></span>
        </div>
        <div class="comparison-mode-content">
          <div class="comparison-mode-name">Равнозначные (Версия 1 -> Версия 2 / Регламент А -> Регламент Б)</div>
          <div class="comparison-mode-description">
            Ищем просто различия и нестыковки, без строгой подчиненности.
          </div>
        </div>
      </div>
    </div>

    <!-- Загрузчики файлов -->
    <StepUploadFile 
      :drag-over="DragOver2"
      :file-data="fileData2"
      :title="'Проверяемый документ'"
      :subtitle="'Выберите файл регламента или перетащите сюда'"
      :upload-target="2"
      @update:drag-over="DragOver2 = $event"
      @update:file-data="fileData2 = $event"
      @file-upload="handleFileUpload"
      @drag-over-event="onDragOver"
      @drag-leave-event="onDragLeave"
      @drop-event="onDrop"
      @error="handleError"
      :is-comparison="true"
    />
    
    <StepUploadFile 
      :drag-over="DragOver3"
      :file-data="fileData3"
      :title="'Определяющий документ'"
      :subtitle="'Выберите файл документа на соответствие которого будет производится проверка или перетащите сюда'"
      :upload-target="3"
      @update:drag-over="DragOver3 = $event"
      @update:file-data="fileData3 = $event"
      @file-upload="handleFileUpload"
      @drag-over-event="onDragOver"
      @drag-leave-event="onDragLeave"
      @drop-event="onDrop"
      @error="handleError"
      :is-comparison="true"
    />

    <!-- Кнопка продолжения -->
    <div class="modal_main_load_content_btn" 
         @click="sendComparisonFiles"
         style="cursor: pointer; margin: 0 auto;"
         v-if="hasBothFiles && comparisonMode !== ''">
      <span>Продолжить</span>
    </div>
  </div>

  <!-- Шаг 2: Прогресс сравнения -->
  <StepProgress 
  v-else-if="flow[1]?.active" 
  :is-rejected="isRejected"
  :percentage="percentage" 
  :circumference="circumference"
  :progress-offset="progressOffset" 
  :is-complete="isRejected || hasComparisonResults"
  :title="'Сравниваем документы'"
  :message="'Идет анализ соответствия...'" 
  @continue="TemporalyNext" 
/>

  <!-- Шаг 3: Результаты сравнения -->
  <StepComparisonProgress v-else-if="flow[2]?.active" :percentage="percentage" :circumference="circumference"
    :progress-offset="progressOffset" :is-complete="hasComparisonResults" :comparison-data="comparisonResults"
    @continue="TemporalyNext" />

  <!-- Шаг 4: Финальный отчет -->
  <StepComparisonFinalReport
      v-else-if="flow[3]?.active && AnalysisCard[1]"
      :comparison-data="comparisonResults"
      :final-items="final"
      :price="'Free'"
      :price-description="'Единоразовая плата'"
      :task-id="taskId"
      @restart="restartFromBeginning"
      @download="someMethod"
      @share="handleShare"
      @save="handleSave"
    />
</template>
      </div>
    </div>
  </div>
</template>

<script>
import ModalHeader from './ModalHeader.vue'
import StepSelection from './StepSelection.vue'
import StepUploadFile from './StepUploadFile.vue'
import StepProgress from './StepProgress.vue'
import StepTableRoles from './StepTableRoles.vue'
import StepProduct from './StepProduct.vue'
import StepNotation from './StepNotation.vue'
import StepFinalReport from './StepFinalReport.vue'
import StepComparisonProgress from './StepComparisonProgress.vue'
import StepComparisonFinalReport from './StepComparisonFinalReport.vue'
export default {
  name: 'BaseModalV3',

  components: {
    StepComparisonFinalReport,
    ModalHeader,
    StepSelection,
    StepUploadFile,
    StepProgress,
    StepTableRoles,
    StepProduct,
    StepNotation,
    StepFinalReport,
    StepComparisonProgress,
  },
  props: {
    text: {
      type: String,
      default: 'ru'
    },
    Id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      ApiLink: process.env.VUE_APP_API_ROOT,
      //ApiLink: '',
      shouldTransition: false,
      comparisonMode: '',
      comparisonResults: {},
      hasComparisonResults: false,
      productEstimation: {  // данные оценки продукта
        cost_per_unit: 0,
        time_per_unit_hours: 0,
        total_roles_involved: 0,
        total_annual_cost: 0,
        capacity_warning: false
      },
      isAnalyzingProduct: false,  // состояние загрузки
      hasProductEstimation: false,  // были ли получены данные

      isLoadingStaffing: false,
      isRejected: false,
      taskId: null,
      pollInterval: null,
      progressInterval: null,  // добавляем
      progressSpeed: 200,       // добавляем, начальная скорость 50мс
      pollingActive: true, // добавляем флаг
      // Данные для финального отчета
      final: [
        'Полный аудит регламента',
        'Анализ структуры документа',
        'Расчет стоимости процесса',
        'Рекомендации по улучшению',
      ],

      // Карточки нотаций
      visardCards: [
        {
          head: 'UML',
          text: 'Unified Modeling Language',
          active: false,
          info: [{
            head: 'О выбранной нотации',
            content: 'UML — универсальный язык моделирования, часто используемый в разработке ПО и проектировании систем.',
            footer: 'Отлично подходит для технических процессов'
          }]
        },
        {
          head: 'BPMN',
          text: 'Business Process Model and Notation',
          active: false,
          info: [{
            head: 'О выбранной нотации',
            content: 'BPMN — стандарт моделирования бизнес-процессов, понятный как бизнес-аналитикам, так и разработчикам.',
            footer: 'Лучший выбор для бизнес-процессов'
          }]
        },
        {
          head: 'EPC',
          text: 'Event-driven Process Chain',
          active: false,
          info: [{
            head: 'О выбранной нотации',
            content: 'EPC — нотация для описания процессов на основе событий и функций, популярная в SAP.',
            footer: 'Хорошо подходит для логистики'
          }]
        },
        {
          head: 'IDEF',
          text: 'Integration Definition',
          active: false,
          info: [{
            head: 'О выбранной нотации',
            content: 'IDEF — семейство методов для моделирования сложных систем и процессов.',
            footer: 'Подходит для технической документации'
          }]
        }
      ],

      // Состояния
      tumbler: false,
      progresOne: false,
      progresTwo: false,
      percentage: 0,
      radius: 50,

      // Drag & Drop состояния
      DragOver1: false,
      DragOver2: false,
      DragOver3: false,
      DragOver4: false,

      // Данные файлов
      fileData: {},
      fileData2: {},
      fileData3: {},
      fileData4: {},

      // Навигация
      ferst: true,
      simpleFlow: [
        { num: 1, textRU: 'Загрузка файла', textEN: 'Upload file', active: false, complite: false, errore: false },
        { num: 2, textRU: 'Проверка типа', textEN: 'Type check', active: false, complite: false, errore: false },
        { num: 3, textRU: 'Проверка структуры', textEN: 'Structure check', active: false, complite: false, errore: false },
        { num: 4, textRU: 'Оценка стоимости', textEN: 'Cost estimation', active: false, complite: false, errore: false },
        { num: 5, textRU: 'Продукт процесса', textEN: 'Process product', active: false, complite: false, errore: false },
        { num: 6, textRU: 'Скачать отчёт', textEN: 'Download report', active: false, complite: false, errore: false },
      ],
      comparisonFlow: [
        { num: 1, textRU: 'Загрузка файлов', textEN: 'Upload files', active: false, complite: false, errore: false },
        { num: 2, textRU: 'Сравнение документов', textEN: 'Comparing documents', active: false, complite: false, errore: false },
        { num: 3, textRU: 'Результаты сравнения', textEN: 'Comparison results', active: false, complite: false, errore: false },
        { num: 4, textRU: 'Скачать отчёт', textEN: 'Download report', active: false, complite: false, errore: false },
      ],
      // Прогресс-бары
      flow: [],

      // Выбор типа аудита
      AnalysisCard: [false, false],
      count: 0,

      // Данные для шагов
      documentInfo: {
        type: 'Регламент',
        format: 'PDF',
        pages: 24
      },

      foundSections: [
        'Титульный лист',
        'Оглавление',
        'Общие положения',
        'Термины и сокращения',
        'Нормативные ссылки',
        'Участники процесса',
        'Описание процесса',
        'Контроль исполнения',
        'Ответственность',
        'Приложения'
      ],
      structureChecklist: {},
      // Данные для таблицы ролей
      roles: [
        { name: 'Менеджер проекта', cost: '2500', count: '1', source: 'Документ' },
        { name: 'Аналитик', cost: '2000', count: '2', source: 'Документ' },
        { name: 'Разработчик', cost: '3000', count: '3', source: 'Документ' },
        { name: 'Тестировщик', cost: '1800', count: '2', source: 'Документ' }
      ],

      roleMappings: [
        { role: 'Менеджер проекта', position: 'Руководитель проекта', cost: '2500', count: '1' },
        { role: 'Аналитик', position: 'Бизнес-аналитик', cost: '2200', count: '2' },
        { role: 'Разработчик', position: 'Ведущий разработчик', cost: '3200', count: '3' }
      ],

      // Данные для продукта
      product: 'Утвержденный проектный план',
      quantity: '50',

      // Текст отчета
      reportText: 'По результатам интеллектуального аудита регламента система Lazarus подтверждает корректность типа документа и в целом достаточную полноту его структуры относительно эталонной модели. Выявлены отдельные зоны риска, связанные с неявным распределением ролей и недостаточной детализацией шагов процесса, что может приводить к росту трудозатрат и операционных рисков. Предварительная оценка стоимости процесса показывает значимый вклад ключевых ролей в общую стоимость, что требует приоритизации оптимизации именно на этих участках. Рекомендуется актуализировать регламент с учётом предложенных Lazarus доработок и использовать обновлённую версию в качестве базового стандарта для дальнейшего управления процессом.'
    }
  },
  computed: {
    // Для прогресс-бара
    circumference() {
      return 2 * Math.PI * this.radius
    },
    progressOffset() {
      return this.circumference - (this.percentage / 100) * this.circumference
    },

    // Проверка наличия файлов для сравнения
    hasBothFiles() {
      return Object.keys(this.fileData2).length > 0 && Object.keys(this.fileData3).length > 0
    }
  },
  methods: {
    restartFromBeginning() {
      this.flow = null
  // Сбрасываем все данные
  this.ferst = true
  this.count = 0
  this.isRejected = false
  this.taskId = null
  this.percentage = 0
  this.progresOne = false
  this.progresTwo = false

  // Сбрасываем файлы
  this.fileData = {}
  this.fileData2 = {}
  this.fileData3 = {}
  this.fileData4 = {}

  // Сбрасываем флаги
  this.isLoadingStaffing = false
  this.isAnalyzingProduct = false
  this.hasProductEstimation = false
  this.productEstimation = {
    cost_per_unit: 0,
    time_per_unit_hours: 0,
    total_roles_involved: 0,
    total_annual_cost: 0,
    capacity_warning: false
  }

  // Сбрасываем роли и маппинги
  this.roles = []
  this.roleMappings = []
  this.structureChecklist = {}

  // Сбрасываем результаты сравнения
  this.comparisonResults = {}
  this.hasComparisonResults = false

  // Сбрасываем продукт
  this.product = 'Утвержденный проектный план'
  this.quantity = '50'

  // Сбрасываем AnalysisCard
  this.AnalysisCard = [false, false]

  
  // Останавливаем polling если активен
  this.stopPolling()

  this.flow = []
},
    async analyzeProduct() {
      if (!this.taskId) {
        console.error('Нет taskId')
        return
      }

      this.isAnalyzingProduct = true

      try {
        const response = await fetch(`${this.ApiLink}/api/v1/tasks/${this.taskId}/product`, {
          method: 'POST',
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            final_product_name: this.product,
            annual_volume: parseInt(this.quantity) || 0
          })
        })

        if (!response.ok) {
          throw new Error(`Ошибка ${response.status}`)
        }

        const data = await response.json()
        console.log('Оценка продукта ПОЛУЧЕНА:', data)  // ← посмотри что тут

        this.productEstimation = data
        this.hasProductEstimation = true

        console.log('hasProductEstimation установлен в true')  // ← проверяем

      } catch (error) {
        console.error('Ошибка при анализе продукта:', error)
        alert('Ошибка при анализе продукта: ' + error.message)
      } finally {
        this.isAnalyzingProduct = false
      }
    },
    async saveRoles() {
      if (!this.taskId) {
        console.error('Нет taskId')
        return
      }

      // Форматируем роли под структуру API
      const rolesForApi = this.roles.map(role => {
        // Определяем source для API
        let source = 'MANUAL' // по умолчанию
        if (role.source === 'Документ') source = 'DOCUMENT'
        else if (role.source === 'Штатное расписание') source = 'STAFFING_FILE'

        return {
          role_name: role.name,
          mapped_job_title: role.mapped_job_title || null,
          hourly_rate: parseInt(role.cost) || 0,
          headcount: parseInt(role.count) || 1,
          hours_per_cycle: 0, // пока 0, можно добавить поле позже
          source: source
        }
      })

      console.log('Отправляю роли:', rolesForApi)

      try {
        const response = await fetch(`${this.ApiLink}/api/v1/tasks/${this.taskId}/roles`, {
          method: 'POST',
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ roles: rolesForApi })
        })

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}))
          throw new Error(errorData.message || `Ошибка ${response.status}`)
        }

        const data = await response.json()
        console.log('Роли сохранены:', data)

        // Переходим на следующий шаг
        this.TemporalyNext()

      } catch (error) {
        console.error('Ошибка при сохранении ролей:', error)
        alert('Ошибка при сохранении ролей: ' + error.message)
      }
    },
    // Загрузка штатного расписания
    async uploadStaffing({ file, target }) {
      if (!this.taskId) {
        console.error('Нет taskId')
        return
      }

      this.isLoadingStaffing = true  // включаем лоадер
      console.log('Загружаю штатное расписание:', file.name)

      const formData = new FormData()
      formData.append('staffing_file', file)

      try {
        const response = await fetch(`${this.ApiLink}/api/v1/tasks/${this.taskId}/staffing`, {
          method: 'POST',
          headers: {
            'accept': 'application/json'
          },
          body: formData
        })

        if (!response.ok) {
          console.error('Ошибка при загрузке штатного расписания')
          this.$emit('upload-error', 'Ошибка при загрузке штатного расписания')
          this.isLoadingStaffing = false  // выключаем лоадер при ошибке
          return
        }

        const data = await response.json()
        console.log('Штатное расписание загружено:', data)

        // Формируем roleMappings из ответа
        if (data.staffing_roles && data.staffing_roles.length > 0) {
          const mappings = data.staffing_roles.map(role => ({
            role: role.job_title || 'Новая роль',
            position: role.job_title || 'Должность',
            cost: role.hourly_rate?.toString() || '0',
            count: '1'  // по умолчанию, так как в ответе нет headcount
          }))
          this.roleMappings = mappings
        }

        this.$emit('staffing-uploaded', { taskId: this.taskId, data })

      } catch (error) {
        console.error('Ошибка при загрузке:', error)
        this.$emit('upload-error', 'Ошибка при загрузке штатного расписания: ' + error.message)
      } finally {
        this.isLoadingStaffing = false  // выключаем лоадер в любом случае
      }
    },
    // Запускаем polling после получения task_id
    startPolling(taskId) {
  this.taskId = taskId
  this.pollingActive = true
  
  if (this.pollInterval) {
    clearInterval(this.pollInterval)
  }
  
  const checkMethod = this.AnalysisCard[0] ? this.checkStatus : this.checkComparisonStatus
  
  this.pollInterval = setInterval(() => {
    checkMethod.call(this)
  }, 2000)
},
    // Проверяем статус
    async checkStatus() {
    // проверяем флаг в самом начале!
    if (!this.taskId || !this.pollingActive) return
    this.isRejected = false
    try {
      const response = await fetch(`${this.ApiLink}/api/v1/tasks/${this.taskId}/status`, {
        method: 'GET',
        headers: {
          'accept': 'application/json'
        }
      })

      if (!response.ok) {
        this.$emit('upload-error')
        this.stopPolling()
        this.TemporalyBack()
        return
      }

      const data = await response.json()
      console.log('Статус:', data.status)

      // Управляем скоростью анимации
      if (data.status === 'CREATED' || data.status === 'AI_CLASSIFYING') {
        this.progressSpeed = this.progressSpeed + 50
        this.changeSpeed()
      } else if (data.status === 'REJECTED_BY_AI') {
        this.isRejected = true 
        this.progressSpeed = 50
        this.changeSpeed()
        this.stopPolling()
      } else if (data.status === 'AI_ANALYZING' && this.count != 1 ) {
        this.progressSpeed = this.progressSpeed + 50
        this.changeSpeed()
      } else if (data.status === 'AWAITING_ROLES') {
              this.progressSpeed = 50
              this.changeSpeed()
              this.stopPolling()
              this.structureChecklist = data.results?.structure?.checklist || {}
              
              // Обновляем роли из ответа
              if (data.results?.roles && data.results.roles.length > 0) {
                const formattedRoles = data.results.roles.map(role => {
                  // Определяем отображаемый источник
                  let sourceText = ''
                  switch(role.source) {
                    case 'DOCUMENT':
                      sourceText = 'Документ'
                      break
                    case 'STAFFING_FILE':
                      sourceText = 'Штатное расписание'
                      break
                    case 'MANUAL':
                      sourceText = 'Добавлено вручную'
                      break
                    default:
                      sourceText = role.source || 'Документ'
                  }
                  
                  return {
                    name: role.role_name || 'Не указано',
                    cost: role.hourly_rate?.toString() || '0',
                    count: role.headcount?.toString() || '1',
                    source: sourceText,
                    // Сохраняем оригинальные данные на будущее
                    originalSource: role.source,
                    mapped_job_title: role.mapped_job_title
                  }
                })
                this.roles = formattedRoles
              }
              
              // Обновляем продукт из ответа
              if (data.results?.product_draft?.name) {
                this.product = data.results.product_draft.name
              }
            }
       else {
        this.progressSpeed = 50
        this.changeSpeed()
        this.stopPolling()
        // Если статус конечный - останавливаем polling

      }

    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error)
    }
  },

// Для второго сценария (сравнение)
async checkComparisonStatus() {
  if (!this.taskId || !this.pollingActive) return
  
  try {
    const response = await fetch(`${this.ApiLink}/api/v1/tasks/${this.taskId}/status`, {
      method: 'GET',
      headers: {
        'accept': 'application/json'
      }
    })

    if (!response.ok) {
      this.$emit('upload-error')
      this.stopPolling()
      this.TemporalyBack()
      return
    }

    const data = await response.json()
    console.log('Comparison статус:', data.status, 'Шаг:', this.count)

    // Сначала проверяем специальные статусы
    if (data.status === 'REJECTED_BY_AI') {
      this.isRejected = true 
      this.progressSpeed = 50
      this.changeSpeed()
      this.stopPolling()
      
      // Не переходим на следующий шаг!
      // Просто ждем пока прогресс дойдет до 100%
    }
    else if (data.status === 'COMPLETED') {
      this.progressSpeed = 50
      this.changeSpeed()
      
      this.comparisonResults = data.results?.comparison || {}
      this.hasComparisonResults = true
      this.shouldTransition = true
      this.stopPolling()
    }
    else {
      // Все остальные статусы - увеличиваем скорость
      this.progressSpeed = this.progressSpeed + 50
      this.changeSpeed()
    }

  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error)
  }
},
startComparisonProgress() {
  if (this.progressInterval) {
    clearInterval(this.progressInterval)
  }

  this.percentage = 0

  this.progressInterval = setInterval(() => {
    this.percentage += 1
    if (this.percentage >= 100) {
      this.percentage = 100
      clearInterval(this.progressInterval)
      
      // Автоматически переходим на следующий шаг
      this.TemporalyNext()
    }
  }, this.progressSpeed)
},
    // Останавливаем polling
    stopPolling() {
      this.progressSpeed = 200
      this.pollingActive = false // выключаем флаг
      if (this.pollInterval) {
        clearInterval(this.pollInterval)
        this.pollInterval = null
        console.log('pollInterval очищен')
      }
    },
    slower() {
      this.progressSpeed = this.progressSpeed + 50
      this.changeSpeed()
    },

    faster() {
      this.progressSpeed = Math.max(50, this.progressSpeed - 50)
      this.changeSpeed()
    },
    // Меняем только скорость, процент не сбрасываем!
// Меняем только скорость, процент не сбрасываем!
changeSpeed() {
  if (this.progressInterval) {
    clearInterval(this.progressInterval)
  }

  // Продолжаем с того же процента, но с новой скоростью
  this.progressInterval = setInterval(() => {
    if (this.percentage < 100) {
      this.percentage += 1
    }
    if (this.percentage >= 100) {
      this.percentage = 100
      this.progresOne = true
      this.progresTwo = true
      clearInterval(this.progressInterval)
      
      // Переходим на следующий шаг только если нет ошибки
      if (this.AnalysisCard[1] && !this.isRejected) {
        this.TemporalyNext()
      }
    }
  }, this.progressSpeed)
},

startComparisonProgress() {
  if (this.progressInterval) {
    clearInterval(this.progressInterval)
  }

  this.percentage = 0

  this.progressInterval = setInterval(() => {
    this.percentage += 1
    if (this.percentage >= 100) {
      this.percentage = 100
      clearInterval(this.progressInterval)
      
      // Автоматически переходим на следующий шаг только если нет ошибки
      if (!this.isRejected) {
        this.TemporalyNext()
      }
    }
  }, this.progressSpeed)
},

    // Запуск анимации прогресса
    startProgress() {
      if (this.progressInterval) {
        clearInterval(this.progressInterval)
      }

      this.percentage = 0
      this.progresOne = false
      this.progresTwo = false

      this.progressInterval = setInterval(() => {
        this.percentage += 1
        if (this.percentage >= 100) {
          this.percentage = 100
          this.progresOne = true
          this.progresTwo = true
          clearInterval(this.progressInterval)
        }
      }, this.progressSpeed)
    },
    async sendComparisonFiles() {
      if (!this.hasBothFiles) {
        console.error('Не все файлы загружены')
        return
      }

      if (!this.comparisonMode) {
        alert('Выберите режим сравнения')
        return
      }

      console.log('Отправляю файлы для сравнения')
      console.log('Режим:', this.comparisonMode)
      console.log('Проверяемый:', this.fileData2.file.name)
      console.log('Эталон:', this.fileData3.file.name)

      const formData = new FormData()
      formData.append('audit_type', 'COMPARISON')
      formData.append('doc_relation', this.comparisonMode)
      formData.append('target_file', this.fileData2.file)
      formData.append('reference_file', this.fileData3.file)
      this.isRejected = false
      try {
        const response = await fetch(this.ApiLink + '/api/v1/tasks/upload', {
          method: 'POST',
          headers: {
            'accept': 'application/json'
          },
          body: formData
        })

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}))
          throw new Error(errorData.message || `Ошибка ${response.status}`)
        }

        const data = await response.json()
        console.log('Успех! Ответ от сервера:', data)

        this.taskId = data.task_id
        this.startPolling(this.taskId)
        this.TemporalyNext()

      } catch (error) {
        console.error('Ошибка при отправке:', error)
        alert('Ошибка при отправке файлов: ' + error.message)
      }
    },
    // Простейшая отправка файла
    async sendFile({ file, target }) {
      console.log('Начинаю отправку файла:', file.name)

      const formData = new FormData()
      formData.append('audit_type', 'SIMPLE')
      formData.append('target_file', file)

      try {
        const response = await fetch(this.ApiLink + '/api/v1/tasks/upload', {
          method: 'POST',
          headers: {
            'accept': 'application/json'
          },
          body: formData
        })

        if (!response.ok) {
          this.$emit('upload-error')
          return
        }

        const data = await response.json()
        console.log('Успех! Ответ от сервера:', data)

        // Сохраняем task_id и запускаем polling
        this.taskId = data.task_id
        this.startPolling(this.taskId)  // ← запускаем polling

        this.TemporalyNext()
      } catch (error) {
        console.error('Ошибка при отправке:', error)
        alert('Ошибка при отправке файла: ' + error.message)
      }
    },
    // Обновление всего массива ролей
    updateRoles(newRoles) {
      this.roles = newRoles
      this.$emit('roles-updated', newRoles)
    },

    // Обновление всего массива маппингов
    updateRoleMappings(newMappings) {
      this.roleMappings = newMappings
      this.$emit('mappings-updated', newMappings)
    },

    // Обработка обновления конкретного поля роли
    handleRoleUpdate({ index, field, value }) {
      console.log(`Роль обновлена: индекс ${index}, поле ${field}, значение ${value}`)
      // Здесь можно добавить автосохранение
    },

    // Обработка обновления маппинга
    handleMappingUpdate({ index, field, value }) {
      console.log(`Маппинг обновлен: индекс ${index}, поле ${field}, значение ${value}`)
    },

    // Обработка добавления новой роли
    handleAddRole(newRole) {
      console.log('Добавлена новая роль:', newRole)
      // Здесь можно отправить на бекенд
      this.$emit('role-added', newRole)
    },

    // Обработка добавления нового маппинга
    handleAddMapping(newMapping) {
      console.log('Добавлен новый маппинг:', newMapping)
      this.$emit('mapping-added', newMapping)
    },

    // Обработка переноса из маппинга в основную таблицу
    handleMoveToMain({ mapping, index }) {
      console.log(`Перенесено из маппинга (индекс ${index}):`, mapping)
      this.$emit('mapping-moved', { mapping, index })
    },

    // Удаление роли (уже есть, но обновим для консистентности)
    deleteRole(index) {
      this.roles = this.roles.filter((_, i) => i !== index)
      this.$emit('role-deleted', index)
    },
    // Навигация по клику на элемент прогресс-бара
    TemporalyFlow(n) {
      this.flow[this.count].active = false
      this.flow[this.count].complite = false
      this.flow[n - 1].active = true
      this.count = n - 1
      if (this.count === 1 || this.count === 2) {
        this.startProgress()
      }

    },

    // Переход со стартового экрана
    TemporalyNextv2() {
  // Принудительно убиваем старый flow
  this.flow = null
  
  this.$nextTick(() => {
    if (this.AnalysisCard[0] || this.AnalysisCard[1]) {
      this.ferst = false

      // Создаём новый flow
      if (this.AnalysisCard[0]) {
        this.flow = this.simpleFlow.map(item => ({ ...item, active: false, complite: false, errore: false }))
      } else {
        this.flow = this.comparisonFlow.map(item => ({ ...item, active: false, complite: false, errore: false }))
      }

      this.flow[0].active = true
    }
  })
  window.scrollTo({
      top: 5,
      behavior: 'smooth' // Плавная прокрутка
    })
},

    // Переход на следующий шаг
    TemporalyNext() {
  this.flow[this.count].active = false
  this.flow[this.count].complite = true
  
  if (this.count < this.flow.length - 1) {
    this.count++
    this.flow[this.count].active = true
    
    // Запускаем прогресс для нужных шагов
    if (this.count === 1 || this.count === 2) {
      if (this.AnalysisCard[1] && this.count === 1) {
        // Для второго сценария на шаге сравнения - специальный прогресс
        this.startComparisonProgress()
      } else {
        // Для всех остальных случаев - обычный прогресс
        this.startProgress()
      }
    }
    
    // Запускаем polling
    if (this.AnalysisCard[0] && this.count === 2) {
      this.startPolling(this.taskId)
    } else if (this.AnalysisCard[1] && this.count === 1) {
      this.startPolling(this.taskId)
    }
  }
  
  this.$emit('step-change', {
    step: this.count,
    stepData: this.flow[this.count]
  })
  window.scrollTo({
      top: 5,
      behavior: 'smooth' // Плавная прокрутка
    })
},

    // Возврат на предыдущий шаг
    TemporalyBack() {
      this.isRejected = false
      if (this.flow[0].active) {
        this.flow[0].active = false
        this.flow[0].complite = false
        this.ferst = true
        this.count = 0
      } else {
        this.flow[this.count].active = false
        this.count--
        this.flow[this.count].active = true
        this.flow[this.count].complite = false
      }
    },

    // Запуск анимации прогресса
    startProgress() {
      if (this.progressInterval) {
        clearInterval(this.progressInterval)
      }

      this.percentage = 0
      this.progresOne = false
      this.progresTwo = false

      this.progressInterval = setInterval(() => {
        this.percentage += 1
        if (this.percentage >= 100) {
          this.percentage = 100
          this.progresOne = true
          this.progresTwo = true
          clearInterval(this.progressInterval)

          this.$emit('processing-complete', {
            step: this.count,
            type: this.count === 1 ? 'type-check' : 'structure-check'
          })
        }
      }, this.progressSpeed)  // ← теперь использует progressSpeed
    },

    // Drag & Drop обработчики
    onDragOver(target) {
      if (target === 1) this.DragOver1 = true
      else if (target === 2) this.DragOver2 = true
      else if (target === 3) this.DragOver3 = true
      else if (target === 4) this.DragOver4 = true
    },

    onDragLeave(target) {
      if (target === 1) this.DragOver1 = false
      else if (target === 2) this.DragOver2 = false
      else if (target === 3) this.DragOver3 = false
      else if (target === 4) this.DragOver4 = false
    },

    onDrop(event, target) {
      // Drop обрабатывается в компоненте StepUploadFile
      // Этот метод вызывается как дополнительное уведомление
      console.log(`File dropped on target ${target}`)
    },

    // Обработка загрузки файлов
    handleFileUpload({ file, target }) {
      // Здесь можно отправлять файл на сервер
      console.log(`File uploaded to target ${target}:`, file.name)

      // Эмитим событие для родительского компонента
      this.$emit('file-uploaded', {
        target,
        file,
        fileData: target === 1 ? this.fileData :
          target === 2 ? this.fileData2 :
            target === 3 ? this.fileData3 :
              this.fileData4
      })
    },

    // Валидация цены (для обратной совместимости)
    validatePrise(event) {
      let cleaned = event.target.value.replace(/\D/g, "")
      cleaned = cleaned.replace(/^0+/, "")
      cleaned = cleaned.slice(0, 6)
      event.target.value = cleaned
      return cleaned ? parseInt(cleaned, 10) : ""
    },

    // Обновление роли в таблице
    updateRole({ index, field, value }) {
      const updatedRoles = [...this.roles]
      updatedRoles[index][field] = value
      this.roles = updatedRoles

      this.$emit('role-updated', { index, field, value })
    },

    // Удаление роли
    deleteRole(index) {
      this.roles = this.roles.filter((_, i) => i !== index)
      this.$emit('role-deleted', index)
    },

    // Выбор нотации
    handleNotationSelect(index) {
      this.$emit('notation-selected', {
        index,
        notation: this.visardCards[index]
      })
    },

    // Обработка ошибок
    handleError(error) {
      console.error('Upload error:', error)
      this.$emit('error', error)
    },

    // Методы для финального экрана
    someMethod() {
      this.$emit('scroll-back')
      this.$emit('download-report')
    },

    handleShare() {
      this.$emit('share-report')
    },

    handleSave() {
      this.$emit('save-report')
    }
  },

  watch: {
    // Отслеживаем изменения важных данных
    fileData: {
      handler(newVal) {
        if (Object.keys(newVal).length > 0) {
          this.$emit('file-loaded', { target: 1, data: newVal })
        }
      },
      deep: true
    },

    fileData2: {
      handler(newVal) {
        if (Object.keys(newVal).length > 0) {
          this.$emit('file-loaded', { target: 2, data: newVal })
        }
      },
      deep: true
    },

    fileData3: {
      handler(newVal) {
        if (Object.keys(newVal).length > 0) {
          this.$emit('file-loaded', { target: 3, data: newVal })
        }
      },
      deep: true
    },

    fileData4: {
      handler(newVal) {
        if (Object.keys(newVal).length > 0) {
          this.$emit('file-loaded', { target: 4, data: newVal })
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.modal {
  width: 100%;
  -webkit-backdrop-filter: blur(32px);
  backdrop-filter: blur(32px);
  border-radius: 24px;
  overflow: hidden;
  border: 1px solid #ffffff32;
}

.modal_content {
  background: #000000b7;
  height: 100%;
  position: absolute;
  width: 100%;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: relative;
  
}

.modal_main {
  width: 100%;
  height: 100%;
  border-radius: 16px;
  overflow-y: auto;
  padding: 8px;
}

.modal_main_load_v2 {
  display: flex;
  gap: 16px;
  height: 100%;
}

.modal_main_load_content_btn {
  display: flex;
  gap: 8px;
  flex-wrap: nowrap;
  width: 100%;
  padding: 18px 40px;
  background: #8A75FF;
  justify-content: center;
  border-radius: 24px;
  max-width: 740px;
  transition: opacity 0.3s;
  cursor: pointer;
}

.modal_main_load_content_btn:hover {
  opacity: 0.9;
}

@media (max-width: 580px) {
  .modal_main_load_v2 {
    flex-direction: column;
  }

  .modal_main_load_content_btn {
    padding: 18px;
  }
}

/* Стили из оригинального компонента */
.modal_head {
  text-align: start;
  margin-left: 46px;
}

.modal_flow_element_mob-count {
  padding: 6px 12px;
  border-radius: 100px;
  color: #8A75FF;
  background: #8A75FF3D;
  font-weight: 700;
  text-wrap: nowrap;
}

.modal_flow_element_mob_count_errore {
  color: #FF3A99;
  background: #FF3A993D;
}

.modal_main_analysis_head_v2 {
  padding: 32px 16px;
  border-radius: 23px;
  border: 1px solid #403F6D;
}

.progress-container_table_one_v2 {
  justify-content: flex-start;
  gap: 16px;
  align-items: center;
}

.progress-container_table_one_v2:last-child {
  border-bottom: none;
}

.modal_main {
  width: 100%;
  height: 100%;
  border-radius: 16px;
  overflow-y: auto;
  flex: 1;
  /* Важно для растягивания */
}

.modal_main_load_v2 {
  display: flex;
  gap: 32px;
  height: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
}

.modal_main_load_v2 .modal_main_load {
  max-width: calc(50% - 32px);
  height: 100%;
  /* На всю высоту */

  /* Минимальная высота */
}

@media (max-width: 580px) {
  .modal_main_load_v2 {
    flex-direction: column;
  }

  .modal_main_load_v2 .modal_main_load {
    max-width: 100%;
    min-height: 350px;
  }
}

/* Стили для кнопок */
.debug-panel {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: #1a1a1a;
  border: 2px solid #8A75FF;
  border-radius: 12px;
  padding: 16px;
  z-index: 9999;
  display: flex;
  gap: 10px;
  box-shadow: 0 0 20px rgba(138, 117, 255, 0.3);
}

.debug-panel button {
  background: #8A75FF;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.debug-panel span {
  color: white;
  padding: 8px;
  background: #333;
  border-radius: 6px;
}

.comparison-mode-selector {
  width: 100%;
  margin-bottom: 24px;
  padding: 16px;
  background: #ffffff0a;
  border: 1px solid #403F6D;
  border-radius: 16px;
}

.comparison-mode-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #fff;
}

.comparison-mode-option {
  display: flex;
  gap: 16px;
  padding: 16px;
  margin-bottom: 8px;
  border: 1px solid transparent;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s;
  justify-content: flex-start;
  text-align: start;
}

.comparison-mode-option:hover {
  background: #ffffff15;
}

.comparison-mode-option.active {
  border-color: #FF00E1;
  background: #c572ba13;
}

.comparison-mode-radio {
  width: 24px;
  height: 24px;
  min-width: 24px;
  border: 2px solid #403F6D;
  border-radius: 50%;
  position: relative;
  margin-top: 2px;
}

.comparison-mode-option.active .comparison-mode-radio {
  border-color: #FF00E1;
}

.radio-dot {
  position: absolute;
  width: 14px;
  height: 14px;
  background: #FF00E1;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.comparison-mode-content {
  flex: 1;
}

.comparison-mode-name {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 4px;
  color: #fff;
}

.comparison-mode-description {
  font-size: 14px;
  color: #888;
  line-height: 1.4;
}

@media (max-width: 580px) {
  .comparison-mode-option {
    flex-direction: column;
    gap: 8px;
  }

  .comparison-mode-radio {
    margin-bottom: 4px;
  }
}
</style>